(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
  class FooterMenu extends HTMLElement {
    constructor() {
      super();
      this.menus = this.querySelectorAll('details-disclosure');
      this.resetHandler = this.reset.bind(this);
      setTimeout(this.resetHandler, 50);
    }

    connectedCallback() {
      window.addEventListener('on:breakpoint-change', this.resetHandler);
    }

    disconnectedCallback() {
      window.removeEventListener('on:breakpoint-change', this.resetHandler);
    }

    reset() {
      this.menus.forEach((menu) => {
        if (theme.mediaMatches.lg) {
          if (!menu.disclosure.open) {
            menu.open();
          }
          menu.toggle.setAttribute('tabindex', '-1');
        } else {
          if (menu.disclosure.open) {
            menu.close();
          }
          menu.toggle.removeAttribute('tabindex');
        }
      });
    }
  }

  customElements.define('footer-menu', FooterMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["parmax-story-teaser"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (customElements.get('parmax-story-teaser')) return;
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  class ParmaxStoryTeaser extends HTMLElement {
    connectedCallback() {
      this.slides = Array.from(this.querySelectorAll('[data-pst-slide]'));
      this.steps = Array.from(this.querySelectorAll('[data-pst-step]'));
      this.progress = this.querySelector('[data-pst-progress]');
      this.stamp = this.querySelector('[data-pst-stamp]');
      this.labels = this.steps.map((st) => st.querySelector('.pst__year').textContent);
      this.interval = Number(this.dataset.interval) || 3500;
      this.index = 0;
      this.visible = false;
      this.paused = false;
      if (this.slides.length < 2) return;

      this.observer = new IntersectionObserver((entries) => {
        this.visible = entries[0].isIntersecting;
        this.visible ? this.play() : this.stop();
      }, { threshold: 0.35 });
      this.observer.observe(this);

      this.onVisibility = () => (document.hidden ? this.stop() : this.visible && this.play());
      document.addEventListener('visibilitychange', this.onVisibility);

      this.addEventListener('shopify:block:select', (e) => {
        const i = this.slides.indexOf(e.target);
        if (i > -1) { this.paused = true; this.stop(); this.show(i, true); }
      });
      this.addEventListener('shopify:block:deselect', () => { this.paused = false; if (this.visible) this.play(); });
    }

    disconnectedCallback() {
      this.stop();
      if (this.observer) this.observer.disconnect();
      document.removeEventListener('visibilitychange', this.onVisibility);
    }

    /* Linea: da punto i a punto i+1 durante l'intervallo */
    animateLine(from, to, duration) {
      if (!this.progress || this.steps.length < 2) return;
      const n = this.steps.length - 1;
      this.progress.style.transition = 'none';
      this.progress.style.transform = `scaleX(${from / n})`;
      void this.progress.offsetWidth;
      this.progress.style.transition = duration ? `transform ${duration}ms linear` : 'none';
      this.progress.style.transform = `scaleX(${to / n})`;
    }

    show(i, instant) {
      this.index = i;
      this.slides.forEach((sl, k) => sl.classList.toggle('is-current', k === i));
      this.steps.forEach((st, k) => {
        st.classList.toggle('is-current', k === i);
        st.classList.toggle('is-past', k <= i);
      });
      if (this.stamp && this.labels[i] !== undefined) {
        this.stamp.classList.add('is-changing');
        setTimeout(() => {
          this.stamp.textContent = this.labels[i];
          this.stamp.classList.remove('is-changing');
        }, instant ? 0 : 350);
      }
      if (instant) this.animateLine(i, i, 0);
    }

    tick() {
      const last = this.slides.length - 1;
      if (this.index < last) {
        this.animateLine(this.index, this.index + 1, this.interval * 0.8);
        this.timer = setTimeout(() => { this.show(this.index + 1); this.tick(); }, this.interval);
      } else {
        /* sosta su "Oggi", poi si riparte dal primo anno */
        this.timer = setTimeout(() => { this.show(0, true); this.tick(); }, this.interval * 1.4);
      }
    }

    play() {
      if (this.paused || this.running || reduceMotion.matches || document.hidden) return;
      this.running = true;
      this.tick();
    }

    stop() {
      this.running = false;
      clearTimeout(this.timer);
    }
  }

  customElements.define('parmax-story-teaser', ParmaxStoryTeaser);
})();

  } catch(e) { console.error(e); }
})();
})();
